export default {
  userUserBaseInfo: { url: '/v1/tenant/user/userBaseInfo' },
};
